import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import './SubmittingMissingPage.css';
import GetListLeaveActions from '../../../redux/GetListLeaveRedux';
import { ArrowLeft, IosRadioButtonOn, Vector } from '../../../assets/icons';

// Phase 1: UI Structure - Basic layout with header and list container ✅ COMPLETE
// Phase 2: Redux Integration - State management and API calls ✅ COMPLETE
// Phase 3: List Display - FlatList equivalent with items ✅ COMPLETE

interface SubmittingMissingPageProps {
  // Phase 1: Basic props
  t: (key: string) => string;
  navigate?: (path: string, params?: any) => void;
  goBack?: () => void;
  
  // Phase 2: Redux props
  currentSettings?: any;
  getListLeaveFetching?: boolean;
  getListLeaveSuccess?: boolean;
  getListLeaveError?: boolean;
  listLeave?: any;
  getListLeave?: (children_id: string, page: number) => void;
}

interface SubmittingMissingPageState {
  // Phase 2: Redux state (matching reference exactly)
  dataLeave: any[];
  page: number;
  selected: string | null;
  leave_id: string | null;
  children_id: string | null;
  sick_note: string | null;
  refreshing: boolean; // Web-specific for refresh button
}

class SubmittingMissingPage extends Component<SubmittingMissingPageProps, SubmittingMissingPageState> {
  onEndReachedCalledDuringMomentum = true;

  constructor(props: SubmittingMissingPageProps) {
    super(props);
    // Phase 2: Call API in constructor (matching reference)
    this.props.getListLeave?.(
      this.props.currentSettings?.child?.salesforce_contact_id,
      1
    );
    this.state = {
      // Phase 2: Initialize Redux state (matching reference exactly)
      dataLeave: [],
      page: 1,
      selected: null,
      leave_id: null,
      children_id: null,
      sick_note: null,
      refreshing: false, // Web-specific for refresh button
    };
  }

  componentDidMount() {
    console.log('SubmittingMissingPage mounted');
    // Phase 2: Redux integration - API call moved to constructor to match reference
  }

  // Phase 2: Redux methods
  getData = async () => {
    this.props.getListLeave?.(
      this.props.currentSettings?.child?.salesforce_contact_id,
      this.state.page
    );
  };

  loadData = () => {
    console.log('Load More clicked - Current state:', {
      currentPage: this.state.page,
      lastPage: this.props.listLeave?.meta?.last_page,
      isFetching: this.props.getListLeaveFetching,
      totalItems: this.state.dataLeave?.length
    });
    
    if (this.props.getListLeaveFetching) {
      console.log('Already fetching, skipping load more');
      return;
    }
    if (this.state.page < this.props.listLeave?.meta?.last_page) {
      console.log('Loading next page:', this.state.page + 1);
      this.setState({ page: this.state.page + 1 }, this.getData);
    } else {
      console.log('No more pages to load');
    }
  };

  _onRefresh = () => {
    this.setState({
      page: 1,
      refreshing: true,
    });
    this.props.getListLeave?.(
      this.props.currentSettings?.child?.salesforce_contact_id,
      1
    );
  };

  _onCheckBox = () => {
    this.props.navigate?.('/calendar/file-uploaded', {
      leave_id: this.state.leave_id,
      children_id: this.state.children_id,
      is_submit_missing_note: true, // For web, we'll use true as default since we don't have navigation.getParam
    });
  };

  // Phase 2: Handle Redux state changes
  async componentDidUpdate(prevProps: SubmittingMissingPageProps) {
    if (!this.props.getListLeaveFetching) {
      if (
        this.props.getListLeaveSuccess &&
        this.props.getListLeaveSuccess !== prevProps.getListLeaveSuccess
      ) {
        if (this.state.page != 1) {
          this.setState({
            dataLeave: this.state.dataLeave.concat(
              this.props.listLeave?.data?.leave_data
            ),
          });
        } else {
          this.setState({
            dataLeave: this.props.listLeave?.data?.leave_data,
            refreshing: false,
          });
        }
      }
    }
  }

  renderListItem = (item: any, index: number) => {
    const isSubmitted = item?.sick_note === "Submitted" || item?.sick_note === "已遞交";
    const isSelected = this.state.selected === item?.id;
    
    return (
      <div
        key={item?.id || index}
        className={`list-item ${isSubmitted ? 'submitted' : 'pending'}`}
      >
        <div
          className="list-item-content"
          onClick={() =>
            this.setState({
              selected: item?.id,
              children_id: item?.children_id,
              leave_id: item?.id,
              sick_note: item?.sick_note,
            })
          }
        >
          <div className="list-item-main">
            <h3 className="list-item-title">
              {this.props.t("select-leavere-quest:sick-leave-request-missing")} {index + 1}
            </h3>
          
            <div className="list-item-details">
              <div className="detail-row">
                <span className="detail-label">
                  {this.props.t("appointment-summary-screen:summary.item.name")}
                </span>
                <span className="detail-value">{item?.name || ""}</span>
              </div>
            
              <div className="detail-row">
                <span className="detail-label">
                  {this.props.t("appointment-summary-screen:summary.item.date")}
                </span>
                <span className="detail-value">
                  {item?.date ? moment(item?.date?.date).format("DD MMMM YYYY") : ""}
                </span>
              </div>
            
              <div className="detail-row">
                <span className="detail-label">
                  {this.props.t("appointment-summary-screen:summary.item.time")}
                </span>
                <span className="detail-value">{item?.time || ""}</span>
              </div>
            
              <div className="detail-row">
                <span className="detail-label">
                  {this.props.t("select-leavere-quest:therapist")}
                </span>
                <span className="detail-value">{item?.therapist || ""}</span>
              </div>
            
              <div className="detail-row">
                <span className="detail-label">
                  {this.props.t("select-leavere-quest:service-type")}
                </span>
                <span className="detail-value">{item?.service_type || ""}</span>
              </div>
            
              <div className="detail-row">
                <span className="detail-label">
                  {this.props.t("select-leavere-quest:sick-note")}
                </span>
                <span className="detail-value">{item?.sick_note || ""}</span>
              </div>
            </div>
          </div>

          {!isSubmitted && (
            <div className="list-item-radio">
              {isSelected ? (
                <IosRadioButtonOn width={20} height={20} />
              ) : (
                <Vector width={20} height={20} />
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const { t } = this.props;

    return (
      <div className="submittingmissing-page">
        {/* Phase 1: Header Structure */}
          <div className="page-header">
            <div className="page-header-inner">
              <div className="header-left">
                <button
                  className="header-button back-button"
                  onClick={() => this.props.goBack?.()}
                >
                  <ArrowLeft width={24} height={24} />
                </button>
                <h1 className="header-title">
                  {t("verify-request:leave-request-list")}
                </h1>
              </div>
              
              <div className="header-right">
                {this.state.selected === null ? (
                  <button className="next-button header-button" disabled>
                    {t("select-booking-category-screen:header.right")}
                  </button>
                ) : (
                  <button
                    className="next-button header-button"
                    onClick={() =>
                      this.state.sick_note === "Submitted" ||
                      this.state.sick_note === "已遞交"
                        ? null
                        : this._onCheckBox()
                    }
                  >
                    {t("select-booking-category-screen:header.right")}
                  </button>
                )}
              </div>
            </div>
        </div>

        {/* Phase 3: List Container */}
        <div 
          className="list-container"
          // onScroll={(e) => {
          //   const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
          //   // Match reference logic: this.state.page <= this.props.listLeave?.meta?.last_page - 1
          //   if (scrollHeight - scrollTop === clientHeight && 
          //       this.state.page <= (this.props.listLeave?.meta?.last_page || 1) - 1 &&
          //       this.onEndReachedCalledDuringMomentum) {
          //     this.onEndReachedCalledDuringMomentum = false;
          //     this.loadData();
          //     setTimeout(() => {
          //       this.onEndReachedCalledDuringMomentum = true;
          //     }, 1000);
          //   }
          // }}
        >
          {/* Refresh button for web (equivalent to RefreshControl) */}
          {/*<div className="refresh-control">
            <button 
              className="refresh-button"
              onClick={this._onRefresh}
              disabled={this.state.refreshing}
            >
              {this.state.refreshing ? this.props.t("verify-request:refreshing") : this.props.t("verify-request:refresh")}
            </button>
          </div>
          */ }

          {/* Phase 3: List items */}
          <div className="list-items">
            {this.state.dataLeave?.map((item, index) => this.renderListItem(item, index))}
          </div>

          {/* Load More Button */}
          {this.state.page < (this.props.listLeave?.meta?.last_page || 1) && (
            <div className="load-more-control">
              <button 
                className="load-more-button comman-btn w-100"
                onClick={this.loadData}
                disabled={this.props.getListLeaveFetching}
              >
                {this.props.getListLeaveFetching ? this.props.t("verify-request:loading") : this.props.t("verify-request:load-more")}
              </button>
              
            </div>
          )}
          
        </div>
      </div>
    );
  }
}

// Phase 2: Redux connection
const mapStateToProps = (state: any) => ({
  currentSettings: state.currentSettings,
  getListLeaveFetching: state.getListLeave?.fetching,
  getListLeaveSuccess: state.getListLeave?.success,
  getListLeaveError: state.getListLeave?.error,
  listLeave: state.getListLeave?.listLeave,
});

const mapDispatchToProps = (dispatch: any) => ({
  getListLeave: (children_id: string, page: number) =>
    dispatch(GetListLeaveActions.getListLeaveRequest(children_id, page)),
});

// Phase 2: Export with Redux connection
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SubmittingMissingPage));

